/**
 * Capture-flow UX copy (Phase 2) — single owner so insight/Continue never read as “saved.”
 * Form imports these; do not redefine submit semantics wording in JSX.
 */

export const ITEM_REQUEST_CAPTURE_COPY = {
  /** Budget-step insight fetch — not a create. */
  insightLoading:
    "Checking what people usually pay… This does not save your request.",
  /** Soft helper near Continue (what / budget). */
  notSavedUntilSubmit:
    "You’re only moving to the next step — your request is saved when you tap Submit.",
  /** Finish-step reinforce before primary CTA. */
  finishSaveHint:
    "Ready? Submit request saves it and starts matching. Back goes to budget without saving.",
  continueCta: "Continue",
  submitCta: "Submit request",
  softWarnAckContinue:
    "You can go to the next step with this budget — you may get fewer matches.",
  /** Notes field — optional extras, not a rewrite of “what”. */
  notesLabel: "Extra details",
  notesOptionalHint: "(optional)",
  notesHelper:
    "Size, brand preference, or condition notes — not a new item type.",
  notesPlaceholder: "Optional details — no phone numbers or links",
  /** Edit escape hatch (H12). */
  editLockedLookingForHint:
    "Type stays locked. To look for something else, create a new request.",
  editCreateNewCta: "Looking for something else? Create a new request",
} as const;
